import { render, staticRenderFns } from "./NavBarTournamentButtonMobileB2C.vue?vue&type=template&id=32fd7bd9&scoped=true&"
import script from "./NavBarTournamentButtonMobileB2C.vue?vue&type=script&lang=js&"
export * from "./NavBarTournamentButtonMobileB2C.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTournamentButtonMobileB2C.vue?vue&type=style&index=0&id=32fd7bd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd7bd9",
  null
  
)

export default component.exports